import { Box, Typography, Button, CircularProgress } from '@mui/material'
import logo from './../resources/freeBILL_logo.png'
import { Form, LoginFormClasses, required, TextInput, useNotify, useSafeSetState, useTranslate } from 'react-admin'
import { apiService } from '../apiService'

export const SendResetPassword = () => {
  
  const translate = useTranslate()
  const notify = useNotify()
  const [loading, setLoading] = useSafeSetState(false)
  const [sent, setSent] = useSafeSetState<boolean>(false)

  const submit = async(values: any) => {
    setLoading(true);
    try {
      var location = window.location
      var backlinkUrl = `${location.href}?page=resetPassword`
      await apiService.UsersApi.sendPasswordResetMail({sendPasswordResetMailCommand: {username: values.username, backlinkUrl: backlinkUrl}})
      notify(translate("resources.authentication.sendResetPassword.feedback"), {type:"success", autoHideDuration: 7000})
      setLoading(false);
      setSent(true)
    } catch (error:any) {
      setLoading(false);
      notify(
        typeof error === 'string'
            ? error
            : typeof error === 'undefined' || !error.message
            ? 'ra.auth.sign_in_error'
            : error.message,
        {
            type: 'error',
            messageArgs: {
                _:
                    typeof error === 'string'
                        ? error
                        : error && error.message
                        ? error.message
                        : undefined,
            },
        }
      )
    }
  }

  return (
    <Box p={5} display={"flex"} width={"100%"} sx={{backgroundColor: "#f3f3fa"}} justifyContent={"center"}>
      <Box width={{xs: "100%", sm: "60%", md: "30%"}}>
        <Box display={"flex"} justifyContent={"center"} >
          <Box 
            component={"img"}
            sx={{height: 35}}
            src={logo}
            display={{xs: "none", sm: "block"}}
          />
        </Box>
        <Box py={2} display={"flex"} justifyContent={"center"}>
          <Typography variant='h6'>{translate("resources.authentication.sendResetPassword.title")}</Typography>
        </Box>
        <Box py={2}>
          <Typography variant='body2' >
            {translate("resources.authentication.sendResetPassword.description")}
          </Typography>
        </Box>
        <Box py={2}>
          <Form
            onSubmit={submit}
            mode="onChange"
            noValidate
          >
            <TextInput 
              autoFocus
              source="username"
              label={translate('ra.auth.username')}
              autoComplete="username"
              validate={required()}
              fullWidth
            />
            <Button
                variant={"contained"}
                type="submit"
                disabled={loading || sent}
                fullWidth
                className={LoginFormClasses.button}
                size='small'
            >
                {loading ? (
                    <CircularProgress
                        className={LoginFormClasses.icon}
                        size={19}
                        thickness={3}
                    />
                ) : (
                  translate("resources.authentication.sendResetPassword.action")
                )}
            </Button>
          </Form>
        </Box>
      </Box>  
    </Box>
  )
}
